<template>
    <div
        class="side-cart"
        v-if="counter > 0"
    >
        <!--<div class="carrello-sidelink d-none d-xl-block" :class="{'fade-left' : show}">
            <a @click="openCart" href="javascript:void(0)">
                <div class="carrello-sidelink__btn">
                    <img src="/images/svg/roeno-25.svg" alt="icona" />
                    <span class="carrello-sidelink__number" v-text="counter"></span>
                    <span class="carrello-sidelink__title">{{$root.translateString('cart')}}</span>
                </div>
            </a>
        </div>-->

        <div class="carrello-mobile-fixed-container d-xl-none">
            <div class="carrello-mobile-fixed">
                <div class="carrello-mobile-fixed__image">
                    <img src="/images/svg/roeno-25.svg" alt="icona" />
                    <div class="carrello-mobile-fixed__count" v-text="counter"></div>
                </div>
                <div class="carrello-mobile-fixed__title">{{$root.translateString('your_cart')}}</div>
                <div class="carrello-mobile-fixed__btn">
                    <a @click="openCart" href="javascript:void(0)"><img src="/images/svg/roeno-17.svg" alt="icona"/></a>
                </div>
            </div>
        </div>

        <div
            class="carrello-mobile-fixed-container  carrello-mobile-fixed-container--visibility-hidden d-xl-none"
        >
            <div class="carrello-mobile-fixed">
                <div class="carrello-mobile-fixed__image">
                    <img src="/images/svg/roeno-25.svg" alt="icona" />
                    <div class="carrello-mobile-fixed__count" v-text="counter"></div>
                </div>
                <div class="carrello-mobile-fixed__title">{{$root.translateString('your_cart')}}</div>
                <div class="carrello-mobile-fixed__btn">
                    <a @click="openCart" href="javascript:void(0)"><img src="/images/svg/roeno-17.svg" alt=""/></a>
                </div>
            </div>
        </div>

    </div>

</template>
<style  scoped>
    .shake {
        animation: shake 1s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    @keyframes shake {
    10%, 90% {
        transform: translateX(-1px);
    }

    20%, 80% {
        transform: translateX(2px);
    }

    30%, 50%, 70% {
        transform: translateX(-4px);
    }

    40%, 60% {
        transform: translateX(4px);
    }
    }

</style>
<script>
export default {
    props: ['initCounter'],
    data() {
        return {
            shake:false,
            counter: 0,
            show: false,
        }
    },
    watcher: {
      counter: function(n, o) {
          if(n > 0 && o == 0) {

          }
      }
    },
    mounted() {
        this.counter = parseInt(this.initCounter);

        if(this.counter > 0) {
            setTimeout(() => {
                this.show = true;
            }, 700)
        }

        this.$eventHub.$on('cart.added', payload => {
            this.counter = parseInt(payload.count);
            this.shake = true;

            setTimeout(() => {
                this.shake = false;
            }, 1000);
        });

        this.$eventHub.$on('cart.updated.simpleQty', payload => {
            this.counter = payload;
        });

    },
    methods: {
      openCart() {
          if($(window).width() < 992) {
              window.location.href = this.$root.langRoute('/carrello');
          }else{
              this.$eventHub.$emit('cart.show', {});
          }
      },
      getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.counter = response.data.count;
            })
        },
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }

            return tmp;
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
}
</script>
